import React from 'react';
import s from '../Card.scss';
import { LinkWrapper } from '../../../components/BaseComp';
import { HomeData } from '../../../models/apis/homeDataAPI';
import { calcTopNewsWidth } from '../../../utils/calcTopNewsWidth';

export const NewsCard = (props: {topNews: HomeData['topNews']}) => {
    const { topNews } = props;

    const { cpcNews, news } = topNews;

    const displayNews = news.slice(0, 33 - cpcNews.length);

    const removeHTML = (str: string): string => str.replace(/<.*?>/g, '');

    return <div className={s.cardContainer} style={{height: 1222}}>
        <h3 className={s.title} style={{ paddingBottom: 14 }}>要闻</h3>
        <div data-spm="top-news1">
            {cpcNews && cpcNews.map((item, index: number) => {
                return (
                    <li key={index + removeHTML(item.title)} className={calcTopNewsWidth(item) > 397 ? s.thin : ''}>
                        <LinkWrapper href={item.url} title={removeHTML(item.title)}><span dangerouslySetInnerHTML={{__html: item.title}} /></LinkWrapper>
                        {
                            item.multipleData.map((t, i: number) => {
                                return (<LinkWrapper href={t.url} key={i + removeHTML(t.title)} className={s.tiny} title={removeHTML(t.title)}>
                                    <span dangerouslySetInnerHTML={{__html: t.title}} />
                                </LinkWrapper>);
                            })
                        }
                    </li>
                );
            })}
        </div>
        <div data-spm="top-news2">
            {displayNews && displayNews.map((item, index: number) => {
                return index === 0
                    ? <div key={index} className={s.hotNews}>
                        <LinkWrapper href={item.url} title={removeHTML(item.title)}>
                            <img src="//statics.itc.cn/asm/static/images/vipnews.png" alt="" />
                            <li>{removeHTML(item.title)}</li>
                        </LinkWrapper>
                    </div>
                    : <li key={index} className={index % 6 === 0 ? s.divide : ""}>
                        <LinkWrapper href={item.url} title={removeHTML(item.title)} key={index}><span dangerouslySetInnerHTML={{__html: item.title}} /></LinkWrapper>
                    </li>;
            })}
        </div>
    </div>;
};



// WEBPACK FOOTER //
// ./src/components/HomeTop/NewsCard/index.tsx